module.exports = "/assets/eaed27956a05774d5f3fb5d3f3efaba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/Z6.png
// module id = 2053
// module chunks = 0